<template>
  <div></div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      isInit: false,
      messagesLimit: 5,
      converseIDs: [],
      gotNotRead: false,
    };
  },
  computed: {
    ...mapGetters([
      "uname",
      "notReadOmniMessages",
      "incomingSocketOmniMessage",
      "chatSocket",
      "omniDifferentTABSent",
      "omniDifferentTABRead",
      "omniConversationClosed",
      "assignedOmniConversation",
      "currentOmniID",
      "ManageOmniChannelPermission",
      "omniChannelPermission",
      "permissions",
      "omniActiveConversations",
      "omniOpenedConversation",
      "omniUsers",
      "omniFailedMsg",
    ]),
    converseAccess() {
      return this.userHasPermisson(
        this.permissions,
        this.omniChannelPermission
      );
    },
    manageAccess() {
      return this.userHasPermisson(
        this.permissions,
        this.ManageOmniChannelPermission
      );
    },
  },
  methods: {
    ...mapMutations([
      "setNotReadOmniMessages",
      "setCurrentOmniID",
      "setOmniCloseOverlay",
      "setOmniClosedCustomer",
      "setOmniActiveConversations",
      "setOmniUsers",
      "setOmniOpenedConversation",
      "setHandleOpenedOmniConversation",
    ]),
    ...mapActions([
      "GetUserActiveOmniConversations",
      "GetCurrentActiveOmniConversations",
      "GetOmniChannelUsers",
      // "GetOmniConversationMessages",
      "SetMessageDialog",
    ]),
    // async loadMoreMessages({ done }) {
    //   // Perform API call
    //   console.log("loading");
    //   try {
    //     const resp = await this.GetOmniConversationMessages({
    //       conversation_id: this.selectedConversation.conversation_id,
    //       offset: this.selectedConversation.messages.length,
    //       limit: this.messagesLimit,
    //     });
    //     if (!resp.success) {
    //       done("ok");
    //       this.SetMessageDialog({ show: true, message: resp.message });
    //       return;
    //     }
    //     this.jumpToID =
    //       this.selectedConversation.messages[
    //         this.selectedConversation.messages.length - 1
    //       ].id;
    //     const converseIDX = this.getConversationIndex(
    //       this.selectedConversation.conversation_id
    //     );
    //     this.handleSelectedConversation(
    //       converseIDX,
    //       true,
    //       resp.messages,
    //       false
    //     );
    //     done("ok");
    //   } catch (err) {
    //     let message = err.message;
    //     if (err.response) {
    //       message = err.response.data.message;
    //     }
    //     this.conversationLoading = false;
    //     this.SetMessageDialog({ show: true, message: message });
    //     done("ok");
    //   }
    // },
    async initChat() {
      if (this.isInit) {
        return;
      }
      this.isInit = true;
      try {
        let conversResp;
        // console.log("in init chat calling user active", this.converseAccess);
        if (this.manageAccess) {
          conversResp = await this.GetCurrentActiveOmniConversations();
        } else if (this.converseAccess) {
          conversResp = await this.GetUserActiveOmniConversations();
        }

        if (!conversResp.success) {
          // this.ShowProgressBar({ show: false, message: "" });
          this.SetMessageDialog({ show: true, message: conversResp.message });
          return;
        }
        const result = conversResp.conversations;
        const initConversations = [];
        for (const res of result) {
          // const user = this.usersList.find((usr) => usr.uname == res.uname);
          const converse = { ...res, isSet: res.messages.length > 0 };
          this.converseIDs.push(converse.conversation_id);
          initConversations.push(converse);
        }
        // this.activeConversations = initConversations;
        this.setOmniActiveConversations(initConversations);
        if (
          this.converseAccess &&
          (this.converseIDs.length > 0) & this.chatSocket
        ) {
          this.chatSocket.send(
            JSON.stringify({ type: 33, not_read: this.converseIDs })
          );
          this.gotNotRead = true;
        }
        if (this.manageAccess) {
          const agentsResp = await this.GetOmniChannelUsers();
          if (!agentsResp.success) {
            // this.ShowProgressBar({ show: false, message: "" });
            this.SetMessageDialog({ show: true, message: agentsResp.message });
            return;
          }
          // this.omniChannelAgents = agentsResp.agents;
          this.setOmniUsers(agentsResp.agents);
        }
        // this.ShowProgressBar({ show: false, message: "" });
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        // this.ShowProgressBar({ show: false, message: "" });
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    isSameDayMessages(msgTime, prevMsgTime) {
      const messageDay = moment.unix(+msgTime).format("YYYY-MM-DD");
      const prevMessageDay = moment.unix(+prevMsgTime).format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(
        moment(prevMessageDay),
        "day"
      );
      return sameDayCond;
    },
    getConversationIndex(converseID) {
      if (!this.omniActiveConversations) {
        return -1;
      }
      return this.omniActiveConversations.findIndex(
        (converse) => converse.conversation_id == converseID
      );
    },
    handleCloseConversation(converseID) {
      // this.closeOverLay = true;
      this.setOmniCloseOverlay(true);
      const idx = this.getConversationIndex(converseID);
      // this.closedCustomer = this.omniActiveConversations[idx].customer;
      this.setOmniClosedCustomer(this.omniActiveConversations[idx].customer);
      setTimeout(() => {
        if (this.omniOpenedConversation?.conversation_id == converseID) {
          // this.selectedConversation = null;
          this.setOmniOpenedConversation(null);
        }
        if (this.omniActiveConversations[idx].not_read_msgs.length > 0) {
          const newNotReadMessages = this.notReadOmniMessages.filter(
            (notRead) =>
              !this.omniActiveConversations[idx].not_read_msgs.includes(
                notRead.message_id
              )
          );
          this.setNotReadOmniMessages(newNotReadMessages);
        }
        if (this.manageAccess) {
          const oldAgentIDX = this.omniUsers.findIndex(
            (omniAgent) =>
              omniAgent.agent == this.omniActiveConversations[idx].agent
          );
          // this.omniChannelAgents[oldAgentIDX].total += -1;
          const agents = JSON.parse(JSON.stringify(this.omniUsers));
          agents[oldAgentIDX].total += -1;
          this.setOmniUsers(agents);
        }
        const activeConversations = JSON.parse(
          JSON.stringify(this.omniActiveConversations)
        );
        activeConversations.splice(idx, 1);
        this.setOmniActiveConversations(activeConversations);
        // this.closeOverLay = false;
        this.setOmniCloseOverlay(false);
        // this.closedCustomer = "";
        this.setOmniClosedCustomer("");
      }, 1300);
    },
  },
  watch: {
    notReadOmniMessages: {
      handler: async function (newVal, oldVal) {
        // console.log("My not read chat messages!!!", newVal);
        const isNewMessage = !oldVal || newVal.length > oldVal?.length;
        if (!isNewMessage) {
          return;
        }

        const activeConversations = this.omniActiveConversations
          ? JSON.parse(JSON.stringify(this.omniActiveConversations))
          : [];
        for (const message of newVal) {
          if (
            ["", "null"].includes(message.conversation_id) ||
            !message.conversation_id
          ) {
            continue;
          }
          const idx = this.getConversationIndex(message.conversation_id);

          // this.activeConversations.findIndex(
          //   (converse) => converse.conversation_id ==
          // );

          const newMessage = {
            message: message.text,
            id: message.message_id,
            time: message.time,
            type: 2,
            is_read: message.is_read,
          };
          if (idx == -1) {
            const NewConversation = {
              customer: message.from,
              agent: message.to,
              omni_type: message.omni_type,
              is_assigned: message.is_assigned,
              conversation_id: message.conversation_id,
              isSet: true,
              count: 1,
              messages: [newMessage],
              last_message: message.text,
              last_update: message.time,
              not_read_msgs: [newMessage.id],
            };
            activeConversations.unshift(NewConversation);
            if (this.manageAccess && this.omniUsers) {
              const agentIDX = this.omniUsers.findIndex(
                (omniAgent) => omniAgent.agent == NewConversation.agent
              );
              const agents = JSON.parse(JSON.stringify(this.omniUsers));
              agents[agentIDX].total += 1;
              this.setOmniUsers(agents);
            }
          } else {
            const msgIDX = activeConversations[idx].messages.findIndex(
              (msg) => msg.id == newMessage.id
            );
            const notmsgIDX = activeConversations[idx].not_read_msgs.findIndex(
              (msgID) => msgID == newMessage.id
            );
            // console.log(
            //   "My checking of indexes",
            //   msgIDX,
            //   notmsgIDX,
            //   newMessage
            // );
            if (msgIDX != -1 && notmsgIDX != -1) {
              continue;
            }

            activeConversations[idx].last_message = newMessage.message;
            activeConversations[idx].last_update = newMessage.time;
            activeConversations[idx].count += 1;
            if (notmsgIDX == -1) {
              if (
                activeConversations[idx].not_read_msgs.length > 0
                // &&
                // activeConversations[idx].not_read_msgs[0] == "i"
              ) {
                activeConversations[idx].not_read_msgs.push(newMessage.id);
              } else {
                activeConversations[idx].not_read_msgs = [newMessage.id];
              }
            }
            if (activeConversations[idx].isSet && msgIDX == -1) {
              activeConversations[idx].messages.unshift(newMessage);
            }
            if (
              this.omniOpenedConversation &&
              this.omniOpenedConversation?.conversation_id ==
                activeConversations[idx].conversation_id
            ) {
              this.setOmniOpenedConversation(activeConversations[idx]);
            }
            activeConversations.unshift(activeConversations.splice(idx, 1)[0]);
          }
        }
        // console.log("My active Converssss", activeConversations);
        this.setOmniActiveConversations(activeConversations);
      },
      deep: true,
    },
    incomingSocketOmniMessage: {
      handler: function (incomingMSG) {
        if (!incomingMSG) {
          return;
        }
        const inSelectedCond =
          this.omniOpenedConversation &&
          this.omniOpenedConversation?.conversation_id ==
            incomingMSG.conversation_id;
        if (!inSelectedCond) {
          return;
        }
        const msgIDX = this.omniOpenedConversation.messages.findIndex(
          (message) => incomingMSG.message_id == message.id
        );
        if (msgIDX != -1) {
          return;
        }
        const msgToPush = {
          message: incomingMSG.text,
          id: incomingMSG.message_id,
          time: incomingMSG.time,
          type: 2,
          is_read: true,
        };
        this.scrollBehavior = "smooth";
        let isSamePrevMsgDay = true;
        if (this.omniOpenedConversation.messages.length > 0) {
          isSamePrevMsgDay = this.isSameDayMessages(
            msgToPush.time,
            this.omniOpenedConversation.messages[0].time
          );
        }
        const idx = this.getConversationIndex(
          this.omniOpenedConversation.conversation_id
        );
        // this.handleSelectedConversation(
        //   idx,
        //   !isSamePrevMsgDay,
        //   [msgToPush],
        //   true
        // );
        this.setHandleOpenedOmniConversation({
          idx: idx,
          isDiffrentDay: !isSamePrevMsgDay,
          messages: [msgToPush],
          fromStart: true,
        });
      },
      deep: true,
      // immediate: true,
    },
    omniDifferentTABRead: {
      handler: function (readMSG) {
        if (!readMSG) {
          return;
        }
        const idx = this.getConversationIndex(readMSG.conversation_id);
        if (idx == -1) {
          return;
        }
        const newNotRead = this.omniActiveConversations[
          idx
        ].not_read_msgs.filter((msgID) => !readMSG.not_read.includes(msgID));
        const activeConversations = JSON.parse(
          JSON.stringify(this.omniActiveConversations)
        );
        activeConversations[idx].not_read_msgs = newNotRead;
        this.setOmniActiveConversations(activeConversations);
      },
      deep: true,
      // immediate: true,
    },
    omniConversationClosed(closeMSG) {
      if (!closeMSG) {
        return;
      }
      const idx = this.getConversationIndex(closeMSG.conversation_id);
      if (idx == -1) {
        return;
      }
      this.handleCloseConversation(closeMSG.conversation_id);
    },
    assignedOmniConversation(assignedConverse) {
      // console.log("My assign converse check!!!!", assignedConverse);
      if (!assignedConverse) {
        return;
      }
      const idx = this.getConversationIndex(assignedConverse.conversation_id);
      const activeConversations = JSON.parse(
        JSON.stringify(this.omniActiveConversations)
      );
      // console.log("My manageAccess", this.manageAccess, "My idx", idx , "my convers", this.omniActiveConversations[idx])
      if (
        !this.manageAccess &&
        idx != -1 &&
        this.uname == this.omniActiveConversations[idx]?.agent
      ) {
        // this.closedCustomer = this.omniActiveConversations[idx].customer;
        this.setOmniClosedCustomer(this.omniActiveConversations[idx].customer);
        // this.closeOverLay = true;
        this.setOmniCloseOverlay(true);

        setTimeout(() => {
          if (
            this.omniOpenedConversation?.conversation_id ==
            this.omniActiveConversations[idx].conversation_id
          ) {
            this.setOmniOpenedConversation(null);
          }
          if (this.omniActiveConversations[idx].not_read_msgs.length > 0) {
            const newNotReadMessages = this.notReadOmniMessages.filter(
              (notRead) =>
                !this.omniActiveConversations[idx].not_read_msgs.includes(
                  notRead.message_id
                )
            );
            this.setNotReadOmniMessages(newNotReadMessages);
          }
          // if (!this.manageAccess) {
          activeConversations.splice(idx, 1);
          this.setOmniActiveConversations(activeConversations);

          // }
          // this.closeOverLay = false;
          this.setOmniCloseOverlay(false);
          // this.closedCustomer = "";
          this.setOmniClosedCustomer("");
        }, 1000);
      } else if (!this.manageAccess && this.uname == assignedConverse.agent) {
        const NewConversation = {
          customer: assignedConverse.customer,
          agent: assignedConverse.agent,
          omni_type: assignedConverse.omni_type,
          is_assigned: assignedConverse.is_assigned,
          conversation_id: assignedConverse.conversation_id,
          isSet: false,
          count: 0,
          messages: [],
          last_message: assignedConverse.text,
          last_update: assignedConverse.time,
        };
        const allUnreadMSGs = this.notReadOmniMessages
          ? [...this.notReadOmniMessages]
          : [];
        let converseNotRead = [];
        if (assignedConverse.not_read.length > 0) {
          converseNotRead = assignedConverse.not_read.map((msgID) => {
            return { message_id: msgID };
          });
          NewConversation.not_read_msgs = assignedConverse.not_read;
        } else {
          converseNotRead.push({ message_id: assignedConverse.message_id });
          NewConversation.not_read_msgs = [assignedConverse.message_id];
        }
        allUnreadMSGs.push(...converseNotRead);
        activeConversations.unshift(NewConversation);
        this.setNotReadOmniMessages(allUnreadMSGs);
        this.setOmniActiveConversations(activeConversations);
      } else if (this.manageAccess) {
        const newAgentIDX = this.omniUsers.findIndex(
          (omniAgent) => omniAgent.agent == assignedConverse.agent
        );
        const oldAgentIDX = this.omniUsers.findIndex(
          (omniAgent) => omniAgent.agent == activeConversations[idx].agent
        );
        activeConversations[idx].agent = assignedConverse.agent;
        const agents = JSON.parse(JSON.stringify(this.omniUsers));
        agents[newAgentIDX].total += 1;
        agents[oldAgentIDX].total += -1;
        this.setOmniUsers(agents);
        this.setOmniActiveConversations(activeConversations);
      }
      // console.log(
      //   "My watch end of assign agent!!!!",
      //   activeConversations,
      //   this.omniUsers
      // );
      // this.setOmniActiveConversations(activeConversations);
      // console.log("My end active", this.omniActiveConversations);
    },
    omniDifferentTABSent(tabMessage) {
      if (!tabMessage) {
        return;
      }
      const newMessage = {
        message: tabMessage.text,
        id: tabMessage.message_id,
        time: tabMessage.time,
        type: 1,
        is_read: true,
      };
      const idx = this.getConversationIndex(tabMessage.conversation_id);
      if (this.currentOmniID == tabMessage.conversation_id) {
        this.scrollBehavior = "smooth";
        let isSamePrevMsgDay = true;
        if (this.omniOpenedConversation.messages.length > 0) {
          isSamePrevMsgDay = this.isSameDayMessages(
            newMessage.time,
            this.omniOpenedConversation.messages[0].time
          );
        }
        const idx = this.getConversationIndex(
          this.omniOpenedConversation.conversation_id
        );
        // this.handleSelectedConversation(
        //   idx,
        //   !isSamePrevMsgDay,
        //   [newMessage],
        //   true
        // );
        this.setHandleOpenedOmniConversation({
          idx: idx,
          isDiffrentDay: !isSamePrevMsgDay,
          messages: [newMessage],
          fromStart: true,
        });
        return;
      }
      const activeConversations = JSON.parse(
        JSON.stringify(this.omniActiveConversations)
      );

      activeConversations[idx].last_message = newMessage.message;
      activeConversations[idx].last_update = newMessage.time;
      activeConversations[idx].count += 1;
      activeConversations[idx].messages.unshift(newMessage);
      activeConversations[idx].isSet = true;
      activeConversations.unshift(activeConversations.splice(idx, 1)[0]);
      this.setOmniActiveConversations(activeConversations);
    },
    omniFailedMsg(failedMsg) {
      if (!failedMsg) {
        return;
      }
      const converseIdx = this.getConversationIndex(failedMsg.conversation_id);
      if (converseIdx == -1) {
        return;
      }
      const msgIdx = this.omniActiveConversations[
        converseIdx
      ].messages.findIndex((msg) => msg.id == failedMsg.message_id);
      if (msgIdx == -1) {
        return;
      }

      setTimeout(() => {
        const activeConversations = JSON.parse(
          JSON.stringify(this.omniActiveConversations)
        );
        activeConversations[converseIdx].messages[msgIdx].failed = true;
        if (
          this.omniOpenedConversation &&
          this.omniOpenedConversation?.conversation_id ==
            failedMsg.conversation_id
        ) {
          this.setOmniOpenedConversation(activeConversations[converseIdx]);
        }
        this.setOmniActiveConversations(activeConversations);
      }, 1000);
    },
    chatSocket(conn) {
      if (!conn) {
        return;
      }
      if (!this.gotNotRead && this.converseIDs.length > 0) {
        conn.send(JSON.stringify({ type: 33, not_read: this.converseIDs }));
        this.gotNotRead = true;
      }
    },
  },
  async mounted() {
    await this.initChat();
  },
  unmounted() {
    this.setCurrentOmniID(null);
    // clearTimeout(this.closingTime);
  },
};
</script>
